import React from "react";
import { Form } from "react-bootstrap";

/**
 * The text filter box under a react-table column header. Shared by Manage Merchants and
 * Merchant Report so both tables filter the same way.
 */
export function ColumnFilter({ column }) {
  const { filterValue, setFilter } = column;

  return (
    <Form.Control
      size="sm"
      //  htmlSize, because `size` is react-bootstrap's own sm/lg prop. The HTML default of
      //  20 makes the input's intrinsic width a floor on the column in an auto-layout
      //  table, which caps how narrow these columns can ever get. custom.css keeps them
      //  from collapsing now that the floor is gone.
      htmlSize={1}
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder={`Filter...`}
      className="form-control-sm"
      style={{ fontSize: "0.875rem" }}
    />
  );
}

export default ColumnFilter;
